/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { authAbandonGet } from '../fn/auth/auth-abandon-get';
import { AuthAbandonGet$Params } from '../fn/auth/auth-abandon-get';
import { authBeginPost } from '../fn/auth/auth-begin-post';
import { AuthBeginPost$Params } from '../fn/auth/auth-begin-post';

@Injectable({ providedIn: 'root' })
export class AuthService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `authBeginPost()` */
  static readonly AuthBeginPostPath = '/auth/begin';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authBeginPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authBeginPost$Response(params?: AuthBeginPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return authBeginPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authBeginPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authBeginPost(params?: AuthBeginPost$Params, context?: HttpContext): Observable<void> {
    return this.authBeginPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `authAbandonGet()` */
  static readonly AuthAbandonGetPath = '/auth/abandon';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authAbandonGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  authAbandonGet$Response(params?: AuthAbandonGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return authAbandonGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authAbandonGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  authAbandonGet(params?: AuthAbandonGet$Params, context?: HttpContext): Observable<void> {
    return this.authAbandonGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
